export default __webpack_public_path__ + "static/media/slime.e6d1d72e.svg";